import { ulid } from 'ulid';
import type { LimitViewModel } from '@/graphql/generated';

type LimitCloneInput = Pick<LimitViewModel,
  | 'name'
  | 'minAmount'
  | 'maxAmount'
  | 'minStayMinutes'
  | 'maxStayMinutes'
>;

export interface ClonedLimitData {
  limitId: string;
  name: string;
  minAmount?: number | null;
  maxAmount?: number | null;
  minStayMinutes?: number | null;
  maxStayMinutes?: number | null;
}

/**
 * Clone a Limit entity
 *
 * - limitId: NEW (regenerated)
 * - facilityId: Handled server-side (not included in CreateLimitInput)
 * - All other fields: COPIED as-is
 */
export function cloneLimit(source: LimitCloneInput): ClonedLimitData {
  return {
    limitId: ulid(),
    name: `${source.name} (Copy)`,
    minAmount: source.minAmount,
    maxAmount: source.maxAmount,
    minStayMinutes: source.minStayMinutes,
    maxStayMinutes: source.maxStayMinutes,
  };
}
